import defaultAuth from "@irati/auth/helpers/defaultAuth";
import authentication from "@irati/auth";
export default (function (tenant) {
    var defaultImage = defaultAuth.userTenant.settings.imageLink;
    if (tenant) {
        return tenant.settings.imageLink !== defaultImage;
    }
    return authentication.userTenant().settings.imageLink !== defaultImage;
});
